import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '手机号',
      prop: 'phone'
    },
    {
      label: '身份证号',
      prop: 'cardNum'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '等级',
      prop: 'leve'
    },
    {
      label: '级别',
      prop: 'coachLevel'
    },
    {
      label: '性别',
      prop: 'sex'
    },
    {
        label: '邮箱',
        prop: 'email'
    }
  ]
}
